


























































































import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  computed,
  onMounted
} from '@vue/composition-api'
import { Volume, TextbookIssue } from '@/shared/types'

export default defineComponent({
  name: 'VolumeForm',
  props: {
    textbook: Object,
    loading: Boolean,
    volume: Object,
  },
  setup(props, context) {
    const VolumeForm = ref(null)
    const data = reactive({
      key: props.volume ? props.volume.key : '',
      name: props.volume ? props.volume.name : '',
      backgroundColor: props.volume ? props.volume.backgroundColor : '',
      fontColor: props.volume ? props.volume.fontColor : '',
      issueIds: props.volume ? (props.volume as Volume).issues.map(el => el.id) : []
    })

    const modes = [
      'hex'
    ]

    const valid = ref(true)
    const backgroundColorElement = ref(null as HTMLElement|null)
    const fontColorElement = ref(null as HTMLElement|null)

    onMounted(() => {
      if (backgroundColorElement.value && props.volume && props.volume.backgroundColor) {
        backgroundColorElement.value.style.backgroundColor = props.volume.backgroundColor
      }
      if (fontColorElement.value && props.volume && props.volume.fontColor) {
        fontColorElement.value.style.backgroundColor = props.volume.fontColor
      }
    })

    const isValidHexColor = (hexString: string) => {
      if (!hexString) {
        return context.root.$t('volume.form.error.colorEmpty')
      }
      if (hexString[0] !== '#') {
        return context.root.$t('volume.form.error.colorWrongPrefix')
      }
      const rest = hexString.substring(1).toLowerCase()
      const validLengths = [3, 6, 8]
      if (!validLengths.includes(rest.length)) {
        return context.root.$t('volume.form.error.colorWrongLength')
      }
      const validCharacters = "0123456789abcdef".split("")
      for(const c of rest) {
        if(!validCharacters.includes(c)) {
          return context.root.$t('volume.form.error.invalidCharacter', {character: c})
        }
      }
      return true
    }

    const rules = reactive({
      nameRules: [
        (v: string) => !!v || context.root.$t('volume.form.error.name'),
      ],
      keyRules: [
        (v: string) => !!v || context.root.$t('volume.form.error.key'),
      ],
      backgroundColorRules: [
        isValidHexColor,
      ],
      fontColorRules: [
        isValidHexColor,
      ],
    })

    const onBackgroundColorInput = (value: string) => {
      if (isValidHexColor(value) === true) {
        backgroundColorElement.value.dataset.invalid = "0"
        backgroundColorElement.value.style.backgroundColor = value 
      } else {
        backgroundColorElement.value.dataset.invalid = "1"
      }
    }

    const onFontColorInput = (value: string) => {
      if (isValidHexColor(value) === true) {
        fontColorElement.value.dataset.invalid = "0"
        fontColorElement.value.style.backgroundColor = value 
      } else {
        fontColorElement.value.dataset.invalid = "1"
      }
    }

    const textbookIssueList = computed(() =>
      ((props.textbook ? props.textbook.issues : []) as TextbookIssue[]).map(issue => ({label: `${issue.isbn}, ${issue.name}`, value: issue.id}))
    )

    const submit = async (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      const form = VolumeForm.value
      if (!form.validate()) {
        setTimeout(() => {
          const firstErrorElement = form.$el.querySelector('.error--text')
          if (firstErrorElement) {
            firstErrorElement.scrollIntoView()
          }
        }, 100)
        return
      }
      const formData = {
        ...data,
        textbookId: props.textbook.id,
      }
      context.emit('submit', formData)
    }

    const isEdit = computed(() => !!props.volume)
    return {
      valid,
      textbookIssueList,
      ...toRefs(data),
      ...toRefs(rules),
      VolumeForm,
      isEdit,
      submit,
      modes,
      onBackgroundColorInput,
      backgroundColorElement,
      onFontColorInput,
      fontColorElement,
      isValidHexColor
    }
  },
})
